
import { defineComponent } from "vue"
import AclLayout from "@/js/Layouts/Acl.vue"

// noinspection JSUnusedGlobalSymbols
export default defineComponent({
    name: "GroupPage",
    components: { AclLayout },
    props: {
        group: {
            type: Object,
            required: false,
            default: () => {},
        },
        errors: {
            type: Object,
            default: () => {},
        },
        permissions: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        form: {
            name: "",
            slug: "",
            description: "",
            permissions: [{ name: "" }],
        },
    }),
    computed: {
        isEditMode(): boolean {
            return !!this.group
        },
    },
    beforeMount() {
        if (this.isEditMode) {
            for (const key in this.form) {
                if (this.group[key]) {
                    // @ts-ignore
                    this.form[key] = this.group[key]
                }
            }
        }
    },
    methods: {
        submit(): void {
            if (this.isEditMode) {
                this.$inertia.put("/acl/groups/" + this.group.id, this.form)
            } else {
                this.$inertia.post("/acl/groups", this.form)
            }
        },
        removePermission(indexForDelete: number): void {
            this.form.permissions = this.form.permissions?.filter(
                (_item, index) => index !== indexForDelete,
            )
        },
        addNewPermission(): void {
            this.form.permissions.push({ name: "" })
        },
    },
})
